import classNames from 'classnames';
import { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCheckoutState } from '../../../utils/checkoutState';
import { config, getAssetUrl } from '../../../utils/config';
import { getStepFromRoute, Step } from '../../../utils/routing';
import './style.scss';

type BreadcrumbStep = {
  key: Step | 'basket';
  isVisible: boolean;
  isEnabled: boolean;
  externalLink?: string;
};

const BreadCrumbs = () => {
  const { checkoutState } = useCheckoutState();
  const { pathname } = useLocation();
  const currentStep = getStepFromRoute(pathname);
  const navigate = useNavigate();
  const basketLink = config.links.find(({ key }) => key === 'basket')?.link;
  const breadcrumbSteps: BreadcrumbStep[] = [
    { key: 'basket', isVisible: !!basketLink, isEnabled: true, externalLink: basketLink },
    { key: 'auth', isVisible: !checkoutState.customer, isEnabled: !!checkoutState.customer },
    { key: 'shipping', isVisible: true, isEnabled: !!checkoutState.orderState.addresses?.shipping },
    { key: 'payment', isVisible: true, isEnabled: !!checkoutState.orderState.addresses?.billing },
  ];

  return (
    <div className="breadcrumbs">
      {breadcrumbSteps
        .filter(({ isVisible }) => isVisible)
        .map(({ key, isEnabled, externalLink }, index) => {
          const onClick = () => {
            if (externalLink) {
              window.location.href = externalLink;
            } else {
              navigate(`/${key}`);
            }
          };
          return (
            <Fragment key={key}>
              {!!index && (
                <img src={getAssetUrl('header/chevronRight.svg')} alt="right" className="breadcrumbs__chevron" />
              )}
              <div
                className={classNames('breadcrumbs__item', { 'breadcrumbs__item--active': currentStep === key })}
                onClick={isEnabled ? onClick : undefined}
              >
                <FormattedMessage id={`header.${key}`} />
              </div>
            </Fragment>
          );
        })}
    </div>
  );
};

export default BreadCrumbs;
